import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { Constants, IConsentOption } from '@shared/utils/constants';
import { Checkbox, mergeStyleSets, Stack, Text } from '@fluentui/react';
import { NeutralColors } from '@fluentui/theme';
export const DisclaimerComponent = (props, context)=>{
    const contentStyles = mergeStyleSets({
        legalTermsContainer: {
            width: '450px',
            padding: '20px',
            border: '2px solid #EAEAEA',
            borderRadius: '2px',
            backgroundColor: NeutralColors.white,
            [`@media (max-width: 1720px)`]: {
                width: '100%'
            }
        }
    });
    const generateDisclaimerText = ()=>{
        const isExcludedCountry = props.hideContactCheckbox;
        const privacyPolicyUrl = props.privacyPolicyUrl;
        const termsOfUseUrl = props.termsOfUseUrl;
        // These are A tags (Links) inside the disclaimer message
        const termsOfUseLink = `<a class="c-hyperlink" target="_blank" href="${termsOfUseUrl}" rel="noreferrer">${context.loc('Purchase_Terms')}</a>`;
        const marketplaceTermsLink = `<a class="c-hyperlink" target="_blank" href="${Constants.MicrosoftTermsURL}" rel="noreferrer">${context.loc('Purchase_Marketplace_Terms')}</a>`;
        const privacyPolicyLink = `<a class="c-hyperlink" target="_blank" href="${privacyPolicyUrl}" rel="noreferrer">${context.loc('Purchase_Privacy')}</a>`;
        // Disclaimer message for OptIn/OptOut/Notice
        const disclaimerWithContactInfo = /*#__PURE__*/ _jsx(Text, {
            variant: "smallPlus",
            children: /*#__PURE__*/ _jsx("span", {
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: `${context.locParams('Checkout_Summary_Disclaimer', [
                        termsOfUseLink,
                        privacyPolicyLink,
                        marketplaceTermsLink
                    ])}`
                }
            })
        });
        // Disclaimer message for Exclude
        const disclaimerWithoutContactInfo = /*#__PURE__*/ _jsx(Text, {
            variant: "smallPlus",
            children: /*#__PURE__*/ _jsx("span", {
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: `${context.locParams('Checkout_Summary_Disclaimer_Exclude', [
                        termsOfUseLink,
                        privacyPolicyLink,
                        marketplaceTermsLink
                    ])}`
                }
            })
        });
        return isExcludedCountry ? disclaimerWithoutContactInfo : disclaimerWithContactInfo;
    };
    const generateConsentCheckbox = ()=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "consentCheckboxClass",
            children: !props.hideContactCheckbox && /*#__PURE__*/ _jsx(Checkbox, {
                "data-bi-id": 'leagGenConsent',
                "data-bi-cN": 'User lead generation consent',
                defaultChecked: props.consentOption === IConsentOption.OptOut,
                onRenderLabel: ()=>/*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx("span", {
                            children: context.loc('Checkout_Summary_leadGen_Consent')
                        })
                    })
            })
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                tokens: {
                    childrenGap: 12
                },
                className: contentStyles.legalTermsContainer,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        block: true,
                        variant: "medium",
                        className: "ms-fontWeight-semibold",
                        children: context.loc('Legal_Terms')
                    }),
                    generateDisclaimerText()
                ]
            }),
            /*#__PURE__*/ _jsx("br", {}),
            generateConsentCheckbox()
        ]
    });
};
DisclaimerComponent.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func
};
